import { render } from "./TheDatePicker.vue?vue&type=template&id=d42cb15a"
import script from "./TheDatePicker.vue?vue&type=script&lang=js"
export * from "./TheDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__